const ProductConfiguratorFieldRestoredEvent = new CustomEvent(
    "product-configurator-4:field-restored",
    { bubbles: true }
  );
  
  class ProductConfigurator extends VariantRadios {
    constructor() {
      super();
  
      this.productRoot = this.closest("article");
      this.summaryList = this.querySelector("ul[data-summary]");
  
      this.initSteps();
      this.buildMedia();
      this.buildHeaderForMobile();
  
      this.productRoot.addEventListener("click", this.onClick.bind(this));
      this.addEventListener("keyup", this.onKeyUp.bind(this));
    }
  
    onClick(ev) {
      let elementWithHref = ev.target.getAttribute("href")
        ? ev.target
        : ev.target.closest("[href^='#']");
  
      this.setCharmSide(ev.target);
  
      if (elementWithHref) {
        ev.preventDefault();
        this.openStep(elementWithHref.getAttribute("href"));
      }
    }
  
    onChange(ev) {
      if (ev.target.type != "radio") return;
  
      this.activateLabelsForSelectedOption(ev.target);
      this.setVariant(ev.target);
  
      this.processAriaControls(ev.target);
      this.processStep(ev.target);
      this.processUpdatables(ev.target);
      this.setProductImages();
      this.setSummaryList();
    }
  
    onKeyUp(ev) {
      this.processStep(ev.target);
      this.setSummaryList();
    }
  
    processAriaControls(el) {
      const ariaControlsTarget = document.getElementById(
        el.getAttribute("aria-controls")
      );
      const ariaControlsTargetExpanded = !!el.dataset.ariaControlsExpanded;
      const ariaControlsTargetIsRequired = !!el.dataset.ariaControlsIsRequired;
      const ariaControlsTargetRequiredElement =
        ariaControlsTarget?.querySelector("[data-required]");
  
      if (ariaControlsTarget) {
        ariaControlsTarget.ariaExpanded = ariaControlsTargetExpanded;
  
        if (ariaControlsTargetRequiredElement) {
          ariaControlsTargetRequiredElement.disabled =
            !ariaControlsTargetIsRequired;
          ariaControlsTargetRequiredElement.required =
            ariaControlsTargetIsRequired;
        }
      }
    }
  
    initSteps() {
      this.steps = this.querySelectorAll(".pc__step");
      this.steps.forEach((step) => {
        step
          .querySelectorAll(".cta--secondary")
          .forEach((cta) => this.processStep(cta));
      });
    }
  
    openStep(id) {
      const activeStepAnchor = this.querySelector(id);
      const activeStepContent = this.querySelector(`${id}-content`);
  
      if (!activeStepContent) {
        return;
      }
  
      const activeStepNavLink = this.querySelector(
        `[aria-controls="${activeStepContent.id}"]`
      );
  
      this.querySelectorAll([
        '.pc__step[aria-expanded="true"]',
        'nav [aria-expanded="true"]',
      ]).forEach((el) => {
        el.ariaExpanded = false;
      });
  
      document.body.scrollIntoView();
  
      activeStepAnchor.parentNode
        .querySelector(".active")
        ?.classList?.remove("active");
      activeStepAnchor.classList.add("active");
  
      activeStepContent.ariaExpanded = true;
      if (activeStepNavLink) activeStepNavLink.ariaExpanded = true;
    }
  
    processStep(el) {
      const step = el.closest(".pc__step");
      const options = step.querySelectorAll(".pc__options li");
      const requiredFieldsSelector =
        '[type="radio"][data-summary]:checked, [type="text"][data-summary][required]';
      const validFieldsSelector =
        '[type="radio"][data-summary]:checked, [type="text"][data-summary][required]:valid';
      const stepButton = step.querySelector(".cta--secondary");
      const navLink = this.querySelector(`[aria-controls=${step.id}]`);
      const optionsAllValid = [...options].every((option) => {
        if (option.classList.contains("hy-optional-input")) return true; // skip validation

        const requiredFields = option.querySelectorAll(requiredFieldsSelector);
        const validFields = option.querySelectorAll(validFieldsSelector);
        return (
          requiredFields.length > 0 && requiredFields.length == validFields.length
        );
      });
  
      stepButton.ariaDisabled = !optionsAllValid;
      if (navLink) navLink.ariaDisabled = !optionsAllValid;
    }
  
    variantsForTitleGeneration() {
      return Array.from(
        this.querySelectorAll([
          'radio-select[data-selected-value] input[type="radio"]:not([name*=properties]):checked',
          'radio-select:not([data-selected-value]) input[type="radio"]:not([name*=properties])[data-checked]',
        ])
      );
    }
  
    setVariantUrl() {}
  
    processUpdatables(el) {
      if (!el.closest("[data-update]")) return;
      if (
        (!el.closest("[data-previous-value]") &&
          el.closest("[data-selected-value]")) ||
        el.closest("[data-previous-value]")?.dataset?.previousValue == el.value
      )
        return;
  
      const url = new URL(location.href);
      url.searchParams.set("variant", this.selectedVariantOption.value);
      url.searchParams.set(
        "section_id",
        el.closest("[data-section-id").dataset.sectionId
      );
  
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const newDocument = new DOMParser().parseFromString(text, "text/html");
  
          document
            .querySelectorAll(`[data-update]`)
            .forEach((existingUpdatable) => {
              const newRestorable = newDocument.querySelector(
                `[data-update="${existingUpdatable.dataset.update}"]`
              );
              const checkedRadioId = existingUpdatable.querySelector(
                "[type=radio]:checked"
              )?.id;
              const existingInputs = existingUpdatable.querySelectorAll(
                "[data-update-restorable][type=text]"
              );
  
              existingUpdatable.innerHTML = newRestorable.innerHTML;
  
              const newCheckedRadio = document.getElementById(checkedRadioId);
              if (newCheckedRadio) {
                newCheckedRadio.checked = true;
                newCheckedRadio.dispatchEvent(RadioSelectCheckedEvent);
              }
  
              existingInputs.forEach((existingInput) => {
                const newInput = document.getElementById(existingInput.id);
                if (!newInput) return;
                newInput.value = existingInput.value;
                newInput.dispatchEvent(ProductConfiguratorFieldRestoredEvent);
              });
  
              this.processStep(existingUpdatable);
            });
  
          let clickedElement = document.getElementById(el.id);
          clickedElement.checked = true;
          clickedElement.dispatchEvent(RadioSelectCheckedEvent);
        });
    }
  
    buildMedia() {
      this.productMediaRoot = this.productRoot.querySelector(".product__media");
      this.flipButtonTemplate = this.querySelector("template[data-flip-button]");
  
      if (this.flipButtonTemplate) {
        this.flipButton = new DOMParser()
          .parseFromString(
            this.querySelector("template[data-flip-button]").innerHTML,
            "text/html"
          )
          .querySelector("a");
  
        this.productMediaRoot.append(this.flipButton);
      }
  
      this.buildHeaderForMobile();
      this.productImages = Array.from(
        this.productRoot.querySelectorAll("better-image:not([data-placeholder]):not([data-placeholder-large])")
      );
    }
  
    buildHeaderForMobile() {
      if (this.header) return;
  
      this.header = this.querySelector(".product__configurator__header");
      //this.header.append(this.productMediaRoot.cloneNode(true));
      const mediaClone = this.productMediaRoot.cloneNode(true);
      const engravingArea = mediaClone.querySelector(".product__media-engraving-area");
      if (engravingArea) {
        engravingArea.classList.add("is-clone-header");
      }
      this.header.append(mediaClone);

  
      this.zoomInButton = this.header.querySelector("dialog-opener");
      this.zoomInButton.addEventListener(
        "click",
        this.prepareMobileDialogForOpen.bind(this)
      );
  
      this.headerDialog = this.header.querySelector("dialog");
      this.headerDialog.append(this.buyButton.cloneNode(true));
    }
  
    prepareMobileDialogForOpen() {
      this.headerDialog.querySelector(".product__media")?.remove();
      //this.headerDialog.append(this.productMediaRoot.cloneNode(true));
      const mediaClone = this.productMediaRoot.cloneNode(true);
      const engravingArea = mediaClone.querySelector(".product__media-engraving-area");
      if (engravingArea) {
        engravingArea.classList.add("is-clone-images");
      }
      this.headerDialog.append(mediaClone);

    }
  
    setProductImages() {
      const attributesToLookAt = [
        "data-gold-color",
        "data-charm-type",
        "data-language",
        "data-gemstone",
        "data-enamel-color",
        "data-charm-back",
        "data-chain",
        "data-halo",
  
        "data-letter-size",
        "data-letter-count",
      ];
  
      let requiredFields = Array.from(
        this.querySelectorAll("radio-select[data-selected-value] :checked")
      );
      let defaultRadios = Array.from(
        this.querySelectorAll(
          "radio-select:not([data-selected-value]) [data-default]"
        )
      );
  
      // Hide all images
      this.productImages.forEach((image) =>
        image.toggleAttribute("hidden", true)
      );
      // Show only matching images
      this.productImages.forEach((image) => {
        let image_attributes = [...image.attributes].filter((attribute) => {
          return attributesToLookAt.includes(attribute.name);
        });
  
        if (image_attributes.length == 0) {
          return;
        }
  
        let everyTrue = image_attributes.every((image_attribute) => {
          if (image_attribute.value == "") {
            return (
              requiredFields.find((radio) => {
                return !!radio.attributes[image_attribute.name];
              }) ||
              defaultRadios.find((radio) => {
                return !!radio.attributes[image_attribute.name];
              })
            );
          }
  
          return (
            requiredFields.find((radio) => {
              return (
                radio.attributes[image_attribute.name]?.value ==
                image_attribute.value
              );
            }) ||
            defaultRadios.find((radio) => {
              return (
                radio.attributes[image_attribute.name]?.value ==
                image_attribute.value
              );
            })
          );
        });
  
        if (everyTrue) {
          image.show();
        }
      });
    }
  
    setCharmSide(el) {
      let charmSideToLookAt =
        el.dataset.side || el.closest("[data-side]")?.dataset?.side || "front";
  
      if (charmSideToLookAt == "toggle") {
        this.charmSide = this.charmSide == "back" ? "front" : "back";
      } else {
        this.charmSide = charmSideToLookAt;
      }
  
      if (this.charmSide == "back") {
        this.charmBackSideSeen = true;
      }
  
      this.productRoot.querySelectorAll(".flippable").forEach((flippable) => {
        flippable.classList.toggle("flipped-once", !!this.charmBackSideSeen);
        flippable.classList.toggle("flipped", this.charmSide == "back");
      });
    }
  
    setSummaryList() {
      this.summaryList.innerHTML = "";
      Array.from(
        this.querySelectorAll(
          'input[type="radio"][data-summary]:checked, input[type="text"][data-summary][required]:valid'
        )
      ).forEach((input) => {
        let summary = decodeURI(input.dataset.summary);
        if (!summary.includes("€")) {
            summary = summary.replace(/\+/, " ");
        }
        let option_name = input.dataset.optionName;
        let liForInput =
          this.summaryList.querySelector(`[data-option='${option_name}']`) ??
          document.createElement("li");
  
        liForInput.dataset.option = option_name;
        liForInput.innerHTML = `${summary.replace("$value", input.value)}`;
        this.summaryList.append(liForInput);
      });
    }
  }
  
  customElements.define("product-configurator-4", ProductConfigurator);
  
  class ProductConfiguratorStep {}
  
  

class EngravingCircleLetters extends HTMLElement {
  connectedCallback() {
    const maxLength = parseInt(this.getAttribute("data-max-length"), 10);
    const showEngravingPath = this.getAttribute("data-engraving-path") === "true";
    const textOffset_top = this.getAttribute("data-text-svg-offset-top");
    const textOffset_bottom = this.getAttribute("data-text-svg-offset-bottom");
    const inputs = this.querySelectorAll("input[type=text]");
    const remainingCounter = this.querySelector(".letters__remaining var");

    // --- Targets: original + clone ---
    const previewDivs = [
      document.querySelector(".product__media-engraving-area .engraving-area-inner"),
      document.querySelector(".product__media-engraving-area.is-clone-header .engraving-area-inner")
    ].filter(Boolean); 

    previewDivs.forEach((previewDiv, index) => {
      const type = index === 0 ? "original" : "clone";
      setupPreview(previewDiv, type, showEngravingPath);
    });

    function setupPreview(previewDiv, type, showEngravingPath) {
      const charmSelected = document.querySelector('radio-select[data-update="charm-type"]');
      if(charmSelected != null){
        const updatePreviewClass = () => {
          const selectedValue = charmSelected?.dataset.selectedValue || "Mini";
          previewDiv.classList.remove("large", "mini");
          previewDiv.classList.add(selectedValue.toLowerCase());
        };
        updatePreviewClass();
        charmSelected.addEventListener("change", updatePreviewClass);
      }
      
      previewDiv.innerHTML = "";
      const svgNS = "http://www.w3.org/2000/svg";
      const svg = document.createElementNS(svgNS, "svg");
      svg.setAttribute("width", "200");
      svg.setAttribute("height", "200");
      svg.setAttribute("viewBox", "0 0 200 200");
      previewDiv.appendChild(svg);

      const defs = document.createElementNS(svgNS, "defs");

      const topPath = document.createElementNS(svgNS, "path");
      const bottomPath = document.createElementNS(svgNS, "path");

      topPath.setAttribute("id", `topPath-${type}`);
      bottomPath.setAttribute("id", `bottomPath-${type}`);
      
      defs.appendChild(topPath);
      defs.appendChild(bottomPath);
      
      // Create filter
      const filter = document.createElementNS(svgNS, "filter");
      filter.setAttribute("id", "inshadow");
      filter.setAttribute("x", "-50%");
      filter.setAttribute("y", "-50%");
      filter.setAttribute("width", "200%");
      filter.setAttribute("height", "200%");
      // feGaussianBlur
      const feGaussianBlur = document.createElementNS(svgNS, "feGaussianBlur");
      feGaussianBlur.setAttribute("in", "SourceAlpha");
      feGaussianBlur.setAttribute("stdDeviation", "0");
      feGaussianBlur.setAttribute("result", "blur");
      filter.appendChild(feGaussianBlur);
      // feOffset
      const feOffset = document.createElementNS(svgNS, "feOffset");
      feOffset.setAttribute("in", "blur");
      feOffset.setAttribute("dx", "0");
      feOffset.setAttribute("dy", "1");
      feOffset.setAttribute("result", "offsetBlur");
      filter.appendChild(feOffset);
      // feFlood
      const feFlood = document.createElementNS(svgNS, "feFlood");
      feFlood.setAttribute("flood-color", "#000000");
      feFlood.setAttribute("flood-opacity", "0.25");
      feFlood.setAttribute("result", "color");
      filter.appendChild(feFlood);
      // feComposite (color in shadow)
      const feComposite1 = document.createElementNS(svgNS, "feComposite");
      feComposite1.setAttribute("in", "color");
      feComposite1.setAttribute("in2", "offsetBlur");
      feComposite1.setAttribute("operator", "in");
      feComposite1.setAttribute("result", "shadow");
      filter.appendChild(feComposite1);
      // feComposite (apply shadow over source)
      const feComposite2 = document.createElementNS(svgNS, "feComposite");
      feComposite2.setAttribute("in", "SourceGraphic");
      feComposite2.setAttribute("in2", "shadow");
      feComposite2.setAttribute("operator", "over");
      filter.appendChild(feComposite2);
      // Append filter to defs
      defs.appendChild(filter);
      
      svg.appendChild(defs);
      
      if (showEngravingPath) {
        const showPath = document.createElementNS(svgNS, "use");
        showPath.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", `#${bottomPath.id}`);
        showPath.setAttribute("stroke", "blue");
        showPath.setAttribute("stroke-width", "0.5");
        showPath.setAttribute("fill", "none");
        svg.appendChild(showPath);
      }
      
      const createText = (hrefId, start_offset, dominant_baseline) => {
        const text = document.createElementNS(svgNS, "text");
        text.setAttribute("text-anchor", "middle");
        text.setAttribute("dominant-baseline", dominant_baseline);
        text.setAttribute("font-family", "Roberta, sans-serif");
        text.setAttribute("letter-spacing", "0.08em");

        const textPath = document.createElementNS(svgNS, "textPath");
        textPath.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", `#${hrefId}`);
        textPath.setAttribute("startOffset", start_offset);

        text.appendChild(textPath);

        svg.appendChild(text);
        return { text, textPath };
      };

      const { text: topText, textPath: topTextPath } = createText(topPath.id, textOffset_top, "middle");
      const { text: bottomText, textPath: bottomTextPath } = createText(bottomPath.id, textOffset_bottom, "mathematical");
      
      const getCircularPaths = (cx, cy, radius) => ({
        top: `M ${cx} ${cy} m 0 ${radius} a ${radius} ${radius} 0 1 1 0.1 0`,
        bottom: `M ${cx} ${cy} m 0 -${radius} a ${radius} ${radius} 0 1 0 0.1 0`
      });

      
      const getRadius = () => {
        const charmSelect = document.querySelector('radio-select[data-update="charm-type"]');
        const selectedValue = charmSelect?.dataset.selectedValue || "Mini";
        if (type === "clone") {
          return selectedValue.toLowerCase() === "large" ? 20 : 16; //smaller for clone
        } else {
          return selectedValue.toLowerCase() === "large" ? 30 : 23; //orignial
        }
      };

      const updatePaths = () => {
        const radius = getRadius();
        const paths = getCircularPaths(100, 100, radius);
        topPath.setAttribute("d", paths.top);
        bottomPath.setAttribute("d", paths.bottom);
      };
      
      const updateFontSize = () => {
        const charmSelect = document.querySelector('radio-select[data-update="charm-type"]');
        const selectedValue = charmSelect?.dataset.selectedValue || "Mini";

        let size = (selectedValue.toLowerCase() === "large") ? "18px" : "14px"; //original
        if (type === "clone") size = (selectedValue.toLowerCase() === "large") ? "12px" : "9px"; // smaller for clone

        topText.setAttribute("font-size", size);
        bottomText.setAttribute("font-size", size);
      };

      const updateText = () => {
        let totalLength = 0;

        inputs.forEach((input) => {
          input.value = input.value.toUpperCase();
          totalLength += input.value.length;
        });

        const remaining = Math.max(0, maxLength - totalLength);
        remainingCounter.textContent = remaining;

        inputs.forEach((input) => input.maxLength = remaining + input.value.length);

        topTextPath.textContent = inputs[0]?.value || "";
        bottomTextPath.textContent = inputs[1]?.value || "";
        updateFontSize();
      };

      const updateColor = () => {
        const enamelSelected = document.querySelector('input[name="properties[Enamel Color]"]:checked');
        if (enamelSelected) {
          const enamelHandle = enamelSelected.dataset.enamelColor || enamelSelected.value;
          const enamelColor = getComputedStyle(document.documentElement)
            .getPropertyValue(`--enamel-${enamelHandle}`)
            .trim();

          if (enamelColor) {
            topText.setAttribute("fill", enamelColor);
            bottomText.setAttribute("fill", enamelColor);
            return;
          }
        }

        const goldSelected = document.querySelector('input[name="properties[Gold Color]"]:checked');
        if (goldSelected) {
          const goldHandle = goldSelected.dataset.goldColor || goldSelected.value.toLowerCase();
          let cssVar = "";
          if (goldHandle === "yellow") cssVar = "--yellow-gold-rgb";
          if (goldHandle === "rose") cssVar = "--rose-gold-rgb";
          if (goldHandle === "white") cssVar = "--white-gold-rgb-2";

          const goldRGB = getComputedStyle(document.documentElement)
            .getPropertyValue(cssVar)
            .trim();

          if (goldRGB) {
            const goldColor = `rgb(${goldRGB} / 50%)`;
            topText.setAttribute("fill", goldColor);
            bottomText.setAttribute("fill", goldColor);
          }
        }
      };

      // --- Event listeners ---
      inputs.forEach((input) => input.addEventListener("input", updateText));

      const enamelRadios = document.querySelectorAll('input[name="properties[Enamel Color]"]');
      enamelRadios.forEach((radio) => radio.addEventListener("change", updateColor));

      const goldRadios = document.querySelectorAll('input[name="properties[Gold Color]"]');
      goldRadios.forEach((radio) => radio.addEventListener("change", updateColor));

      const charmSelect = document.querySelector('radio-select[data-update="charm-type"]');
      charmSelect.addEventListener("change", () => {
        updatePaths();
        updateText();
      });

      updatePaths();
      updateText();
      updateColor();
      
      /* Placeholder Large image without Gold color */
      const goldRadiosPlaceholder = document.querySelectorAll('input[name="properties[Gold Color]"]');
      goldRadiosPlaceholder.forEach((radio) => radio.addEventListener("change", () => checkPlaceholderLargeImage(true)));
      const charmSelectPlaceholder = document.querySelector('radio-select[data-update="charm-type"]');
      charmSelectPlaceholder.addEventListener("change", () => {
        const selectedValue = charmSelectPlaceholder.getAttribute("data-selected-value");
        const goldSelectedValue = document.querySelector('radio-select.rs-gold-color-option')?.getAttribute("data-selected-value");
        if (selectedValue === "Large") {
          if (!goldSelectedValue) {
            checkPlaceholderLargeImage(false);
          } else {
            checkPlaceholderLargeImage(true); // Hide if gold color is selected
          }
        } else if (selectedValue === "Mini") {
          checkPlaceholderLargeImage(true); 
        }
      });
      
      checkPlaceholderLargeImage(true); // Initial check
      
      function checkPlaceholderLargeImage(shouldHide) {
        const placeholderLargeImage = document.querySelectorAll('[data-placeholder-large]');
        placeholderLargeImage.forEach((img) => {
          if( shouldHide ) {
            img.classList.add("hidden");
          } else {
            img.classList.remove("hidden");
          }
          console.log("shouldhide",shouldHide);
        });
      }
    }
  }
}

customElements.define("engraving-circle-letters", EngravingCircleLetters);
